// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__XwX_8","skeleton-animation":"styles_skeleton-animation__pANn6"};